import React, { useState, useEffect, useRef } from 'react';
import './reportlogviewer.css';
import PDFViewer from 'pdf-viewer-reactjs';
import ReactSwitch from 'react-switch';
import * as apiClient from "../../../common/apiClient";
import LogDone from '../../../assets/logdone.svg';
import * as App_Constant from "../../../common/constants";

const ReportLogsViewer = (props) => {
    const [modalIsOpen, setModalIsOpen] = useState(true);
    const [progress, setProgress] = useState(0);
    const tableRef = useRef(null); // Create a ref for the table element
    const [logData, setLogData] = useState([]);
    const [requestId, setRequestId] = useState(props.request_id);
    
    
    const [requestDetail, setRequestDetail] = useState(null);
    const [newlyAddedRowIds, setNewlyAddedRowIds] = useState([]); // State to track newly added row IDs

    useEffect(() => {
        loadReport(props.request_id);
        const interval = setInterval(() => {
            loadReport(props.request_id);
        }, 10000);
        return () => clearInterval(interval);
    }, []);

    const closeModal = () => {
        props.close();
        setModalIsOpen(false);
    };

    const loadReport = (request_Id) => {  
        apiClient.get(`requests/getactiveRequestLogsDetail/${request_Id}`, null).then((response) => {
            if (response) { 
                setRequestDetail(response.activeScan[0]);
                setLogData(response.logs);
                if (response.activeScan[0].step_value) {
                    setProgress(parseInt(response.activeScan[0].step_value));
                }
                if (tableRef.current) {
                    tableRef.current.scrollTop = tableRef.current.scrollHeight;
                }

                // Identify newly added rows and update state
                const newRows = response.logs.filter(log => !logData.some(existingLog => existingLog.id === log.id));
                if (newRows.length > 0) {
                    setNewlyAddedRowIds(newRows.map(row => row.id));
                }
            }
        }).catch((err) => { 
            // Handle error
        });
    };

    return (
        <div>
            {modalIsOpen && (
                <div className="custom-modal-overlay">
                    <div className="app">
                        <div className="center-right-section">
                            <div>
                                <div className="log-close-button" >
                                    <span className='log-close-button1' onClick={closeModal}>&times;</span>
                                </div>
                                {requestDetail != null && (
                                    <div className='log-panel'>
                                        <div className='log-car-name'>
                                            {requestDetail.car_name}
                                        </div>
                                        <div className='log-car-section'>
                                            <div className='log-car-image-box'>
                                                <img className='log-car-image' src={requestDetail.img_url ? requestDetail.img_url : App_Constant.NO_CAR} />
                                            </div>
                                            <div className='log-car-detail-box' style={{ marginLeft: 100 }}>
                                                <div className='log-car-detail-box-item'>
                                                    <div className='log-car-detail-box-label'>
                                                        Vin :
                                                    </div>
                                                    <div className='log-car-detail-box-value'>
                                                        {requestDetail.vin_no}
                                                    </div>
                                                </div>
                                                <div className='log-car-detail-box-item'>
                                                    <div className='log-car-detail-box-label'>
                                                        Scan Start :
                                                    </div>
                                                    <div className='log-car-detail-box-value'>
                                                        {apiClient.formatDate(requestDetail.start_scan_date)}
                                                    </div>
                                                </div>
                                                <div className='log-car-detail-box-item'>
                                                    <div className='log-car-detail-box-label'>
                                                        FLW :
                                                    </div>
                                                    <div className='log-car-detail-box-value'>
                                                        {requestDetail.user_name}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='log-car-detail-box' style={{ marginLeft: 100 }}>
                                                <div className='log-car-detail-box-item'>
                                                    <div className='log-car-detail-box-label'>
                                                        Last Scan :
                                                    </div>
                                                    <div className='log-car-detail-box-value'>
                                                        {apiClient.formatDate(requestDetail.last_scan_date)}
                                                    </div>
                                                </div>
                                                <div className='log-car-detail-box-item'>
                                                    <div className='log-car-detail-box-label'>
                                                        Car Owner:
                                                    </div>
                                                    <div className='log-car-detail-box-value'>
                                                        {requestDetail.customer_first_name}{" "}{requestDetail.customer_last_name}
                                                    </div>
                                                </div>
                                                <div className='log-car-detail-box-item'>
                                                    <div className='log-car-detail-box-label'>
                                                        Status :
                                                    </div>
                                                    <div className='log-car-detail-box-value'>
                                                        {requestDetail.vehicle_status != null ? requestDetail.vehicle_status : 'NA'}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='log-progress-main-container' >
                                            <div className="log-progress-container">
                                                <div className="log-progress-bar" style={{ width: `${progress}%` }}>
                                                    <span className="log-progress-label">{progress}%</span>
                                                </div>
                                            </div>
                                         {props.canStop &&   <div className='log-progress-stop' >
                                                Stop
                                            </div>
                                        }
                                        </div>
                                    </div>
                                )}

                                
                                    <div style={{ marginTop: 20 }}>
                                    {requestDetail != null &&  <div className='logs-rows' >
                                            <div className='logs-rows-col1'>Report Logs</div> 
                                            <div className='logs-rows-col2'>{requestDetail && requestDetail.remarks? requestDetail.remarks:null}</div>
                                        </div>
}
                                        {logData.length>0 && (        <div className='log-table-container' ref={tableRef}>
                                            <table>
                                                <thead>
                                                    <tr>
                                                        <th>System</th>
                                                        <th>Monitor Status</th>
                                                        <th>Configure</th>
                                                        <th>ROB</th>
                                                        <th>DTC</th>
                                                        <th>Update</th>
                                                        <th>Status</th>
                                                        <th></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {logData.map(item => (
                                                        <tr key={item} className={newlyAddedRowIds.includes(item.id) ? 'row-added-fade-in ' : ''}>
                                                            <td>{item.value1}</td>
                                                            <td>{item.value2}</td>
                                                            <td>{item.value3}</td>
                                                            <td>{item.value4}</td>
                                                            <td>{item.value5}</td>
                                                            <td>{item.value6}</td>
                                                            <td className="done">Done</td>
                                                            <td>
                                                                <img src={LogDone} />
                                                            </td>
                                                        </tr>
                                                    ))}
                                                    {progress < 100 && (
                                                        <tr>
                                                            <td colSpan="2" style={{ textAlign: 'right' }}>
                                                                <h5>Scanning Vehicle</h5>
                                                                <div className="loader">
                                                                    <div></div>
                                                                    <div></div>
                                                                    <div></div>
                                                                </div>
                                                            </td>
                                                            <td colSpan="6" style={{ textAlign: 'right' }}>
                                                                
                                                            </td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>)}
                                    </div>
                                
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ReportLogsViewer;
